import { render, staticRenderFns } from "./SummaryTab1.vue?vue&type=template&id=4a788252&scoped=true&lang=pug&"
import script from "./SummaryTab1.vue?vue&type=script&lang=js&"
export * from "./SummaryTab1.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTab1.vue?vue&type=style&index=0&id=4a788252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a788252",
  null
  
)

export default component.exports